module.exports = "/_next/static/media/3715024d8c99501a1fe264405a1a34e4.png";